// @flow
import { css } from "styled-components";
import { media, Gravatar, smallHeading, mediumHeading } from "@nested/brand";
import { BookIntroCall } from "./BookIntroCall";

const wrapperStyle = css`
  background-color: ${({ theme }) => theme.palette.hague};
  padding: 40px 20px;
  text-align: center;

  ${media.desktop`
    padding: 60px 20px;
  `}
`;

const gravatarStyle = css`
  width: 162px;
  height: 162px;
  border: 5px solid white;
  margin: 0px;
`;

const textStyle = css`
  ${smallHeading}
  color: white;
  max-width: 328px;
  margin: auto;
  margin-top: 20px;

  ${media.desktop`
    ${mediumHeading}
    color: white;
    max-width: 570px;
  `}
`;

const buttonWrapperStyle = css`
  margin-top: 20px;
`;

type Props = {
  rmFirstName: string,
  rmEmail: string,
};

export const BookCallSection = ({ rmFirstName, rmEmail }: Props) => (
  <section css={wrapperStyle}>
    <div>
      <Gravatar
        size={324}
        css={gravatarStyle}
        email={rmEmail}
        className="chromatic-ignore"
      />
      <div css={textStyle}>
        Speak to {rmFirstName}, your local agent to arrange your valuation
        today.
      </div>
      <div css={buttonWrapperStyle}>
        <BookIntroCall />
      </div>
    </div>
  </section>
);
